import { render, staticRenderFns } from "./upload-view.vue?vue&type=template&id=1297433f&scoped=true&"
import script from "./upload-view.vue?vue&type=script&lang=js&"
export * from "./upload-view.vue?vue&type=script&lang=js&"
import style0 from "./upload-view.vue?vue&type=style&index=0&id=1297433f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1297433f",
  null
  
)

export default component.exports